import type { FaireProductEntity } from "../../entity_types/product";

export const p_wfuvsvfgu9: FaireProductEntity = {
  token: "p_wfuvsvfgu9",
  type: "product",
  name: "Rye Stemless Wine Glass / Juice Glass / Set of 2",
  brandToken: "b_dtfc7uc37e",
  brandName: "Aaron Probyn US",
  imageUrl:
    "https://cdn.faire.com/fastly/01f50759578a57044909d66cfd15f87545c52279fd27aa8c7bd5a8e4ff501c8e.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/12fc10b6eccbf46a86eadbd4a19089a89976b860d75a2a133f876fb34702d72b.jpeg",
    "https://cdn.faire.com/fastly/178b2d25aaad1ff15ee39b6c9cc5a329b5e8304a834755ad4b03070e8f61f633.jpeg",
    "https://cdn.faire.com/fastly/b0d3f3f9d2b68e67365d2d8007d46607040f4445c769caca5002a4684805d0b2.jpeg",
    "https://cdn.faire.com/fastly/436c06a9d5c8764c84f6c0dcab645b9e04e38b560bc55cf7caae127fba64d5b2.jpeg",
    "https://cdn.faire.com/fastly/2f88c78ed97ab393de926bec254613aeb953cb59fc64fd8a7cf2e63ed306c7c7.jpeg",
  ],
  priceDollars: 25,
  description:
    'RYE glassware range has been designed to elevate the drinking experience, whether it is water, beer, wine or a meticulously mixed cocktail. The glasses are skilfully hand crafted from a robust borosilicate glass. The range is well-proportioned, graphic in form, and the subtle accent of coloured glass elevates the drink whilst still allowing you to appreciate the shade of the drink.\n\n• This size is perfect for wine or juice.\n• Packed as a set of 2\n• Size: D 6.8cm x H 9.5cm / D 2.7" x H 3.7"\n• Capacity: 260 ml / 9 fl oz\n\n• Perfect addition to Autumn / Fall / Christmas / Holiday / Thanksgiving season collection!',
  tags: [],
  msrpDollars: 50,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-05-04T23:53:23.039Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
